import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M10.0639 12.6804V6.77415L13.017 9.72727L10.0639 12.6804ZM2 10.2642V4H3.07386V10.2642H2ZM2.02983 10.2642V9.19034H10.9688V10.2642H2.02983Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'ArrowLevelDownRight');

export default Icon;
